import React, { useState } from 'react';
import '../styles/EvaluationResults.css';

function EvaluationResults({ evaluation, breakdown }) {
  const [expandedSections, setExpandedSections] = useState({
    tests: false,
    review: false
  });

  if (!evaluation) {
    return (
      <div className="evaluation-results">
        <p className="no-evaluation">No evaluation available yet</p>
      </div>
    );
  }

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const getScoreColor = (score) => {
    if (score >= 90) return '#10b981';
    if (score >= 70) return '#f59e0b';
    return '#ef4444';
  };

  const passRate = breakdown?.test_pass_rate || (
    evaluation.tests_total > 0
      ? ((evaluation.tests_passed / evaluation.tests_total) * 100).toFixed(1)
      : 0
  );

  return (
    <div className="evaluation-results">
      <div className="evaluation-header">
        <h3>Evaluation Results</h3>
        <div className="quality-score" style={{ color: getScoreColor(evaluation.quality_score) }}>
          <span className="score-label">Quality Score:</span>
          <span className="score-value">{evaluation.quality_score.toFixed(1)}/100</span>
        </div>
      </div>

      <div className="evaluation-summary">
        <div className="summary-item">
          <div className="summary-label">Tests Passed</div>
          <div className="summary-value">
            {evaluation.tests_passed}/{evaluation.tests_total}
            <span className="summary-percentage">({passRate}%)</span>
          </div>
        </div>
        <div className="summary-item">
          <div className="summary-label">Model Used</div>
          <div className="summary-value">{evaluation.evaluation_model || 'GPT-5.6'}</div>
        </div>
        <div className="summary-item">
          <div className="summary-label">Evaluated</div>
          <div className="summary-value">
            {new Date(evaluation.evaluated_at).toLocaleDateString()}
          </div>
        </div>
      </div>

      {evaluation.test_results && evaluation.test_results.length > 0 && (
        <div className="evaluation-section">
          <div
            className="section-header"
            onClick={() => toggleSection('tests')}
          >
            <h4>Test Results ({evaluation.tests_passed}/{evaluation.tests_total} passed)</h4>
            <span className="toggle-icon">{expandedSections.tests ? '▼' : '▶'}</span>
          </div>
          {expandedSections.tests && (
            <div className="section-content">
              {evaluation.test_results.map((test, index) => (
                <div key={index} className={`test-result ${test.passed ? 'passed' : 'failed'}`}>
                  <div className="test-header">
                    <span className="test-status-icon">
                      {test.passed ? '✓' : '✗'}
                    </span>
                    <span className="test-name">{test.test_name}</span>
                    {test.score !== undefined && (
                      <span className="test-score">{test.score}/100</span>
                    )}
                  </div>
                  {test.feedback && (
                    <div className="test-feedback">{test.feedback}</div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {evaluation.code_review_feedback && (
        <div className="evaluation-section">
          <div
            className="section-header"
            onClick={() => toggleSection('review')}
          >
            <h4>Code Review Feedback</h4>
            <span className="toggle-icon">{expandedSections.review ? '▼' : '▶'}</span>
          </div>
          {expandedSections.review && (
            <div className="section-content">
              <div className="code-review-feedback">
                {evaluation.code_review_feedback}
              </div>
            </div>
          )}
        </div>
      )}

      {breakdown && (
        <div className="evaluation-breakdown">
          <h4>Score Breakdown</h4>
          <div className="breakdown-items">
            {breakdown.test_pass_rate !== undefined && (
              <div className="breakdown-item">
                <span className="breakdown-label">Test Pass Rate (40%)</span>
                <span className="breakdown-value">{breakdown.test_pass_rate}%</span>
              </div>
            )}
            {breakdown.code_quality_score !== undefined && (
              <div className="breakdown-item">
                <span className="breakdown-label">Code Quality (30%)</span>
                <span className="breakdown-value">{breakdown.code_quality_score}/100</span>
              </div>
            )}
            {breakdown.acceptance_coverage !== undefined && (
              <div className="breakdown-item">
                <span className="breakdown-label">Acceptance Coverage (20%)</span>
                <span className="breakdown-value">{breakdown.acceptance_coverage}/100</span>
              </div>
            )}
            {breakdown.clarity_score !== undefined && (
              <div className="breakdown-item">
                <span className="breakdown-label">Clarity (10%)</span>
                <span className="breakdown-value">{breakdown.clarity_score}/100</span>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default EvaluationResults;
